import React, { useEffect, useState } from 'react';
const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;
const STORAGE_KEY = 'countdown_target';
function getTarget(): number {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const target = parseInt(stored, 10);
    if (target > Date.now()) return target;
  }
  const target = Date.now() + FIFTEEN_MINUTES_MS;
  localStorage.setItem(STORAGE_KEY, target.toString());
  return target;
}
export function TopCountdownBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const target = getTarget();
    const calculateTimeLeft = () => {
      const difference = target - Date.now();
      if (difference > 0) {
        setTimeLeft({
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        setTimeLeft({
          minutes: 0,
          seconds: 0
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white py-2.5 px-4 shadow-lg shadow-red-900/30" data-id="element-238">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm md:text-base font-bold tracking-wide" data-id="element-239">
        <span className="flex items-center gap-1.5" data-id="element-240">
          <span className="text-lg" data-id="element-241">⏳</span>
          <span data-id="element-242">OFERTA EXPIRA EN:</span>
        </span>

        <span className="font-mono text-yellow-300 text-base md:text-lg tabular-nums" data-id="element-243">
          {pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
        </span>

        <span className="hidden md:inline text-red-300" data-id="element-244">|</span>

        <span className="flex items-center gap-1.5" data-id="element-245">
          <span className="text-lg" data-id="element-246">🔥</span>
          <span className="text-yellow-200 animate-pulse" data-id="element-247">CUPOS LIMITADOS</span>
        </span>
      </div>
    </div>;
}